import classes from './Banner.module.scss';
import Button from "../../GlobalComponents/Button/Button";
import bg_01 from '../../../assets/img/Home/Banner/bg_01.avif';
import bg_02 from '../../../assets/img/Home/Banner/bg_02.avif';
import bg_03 from '../../../assets/img/Home/Banner/bg_03.avif';
import bg_04 from '../../../assets/img/Home/Banner/bg_04.avif';
import Carousel from "./Carousel/Carousel";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

const cards = [
    {
        title: 'home.banner.card_01.title',
        subtitle: 'home.banner.card_01.subtitle',
        bg: bg_01,
        url: 'services',
    },
    {
        title: 'home.banner.card_02.title',
        subtitle: 'home.banner.card_02.subtitle',
        bg: bg_02,
        url: 'services/mechanical-works',
    },
    {
        title: 'home.banner.card_03.title',
        subtitle: 'home.banner.card_03.subtitle',
        bg: bg_03,
        url: 'services/electrical-services',
    },
    {
        title: 'home.banner.card_04.title',
        subtitle: 'home.banner.card_04.subtitle',
        bg: bg_04,
        url: 'services/plumbing',
    },
];

const Banner = () => {
    const { t } = useTranslation();

    const titleRef = useRef(null);
    const subtitleRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const [prevIndex, setPrevIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const total = cards.length;

    const changeSlide = (nextIndex) => {
        if (isAnimating || nextIndex === activeIndex) return;

        setIsAnimating(true);
        setActiveIndex(nextIndex);

        setTimeout(() => {
            setPrevIndex(nextIndex);
        }, 500);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            changeSlide((activeIndex + 1) % total);
        }, 7000);

        return () => clearInterval(interval);
    }, [activeIndex, total, isAnimating]);

    // fade OUT
    useEffect(() => {
        gsap.to(titleRef.current, {
            opacity: 0,
            x: -200,
            duration: 0.5,
            ease: 'power2.out',
        });
        gsap.to(subtitleRef.current, {
            opacity: 0,
            y: 100,
            duration: 0.5,
            ease: 'power2.out',
        });
    }, [activeIndex]);

    // fade IN
    useEffect(() => {
        const tl = gsap.timeline({
            onComplete: () => setIsAnimating(false),
        });

        tl.fromTo(
            titleRef.current,
            { opacity: 0, x: 200 },
            {
                opacity: 1,
                x: 0,
                duration: 0.6,
                ease: 'power2.out',
            }
        ).fromTo(
            subtitleRef.current,
            { opacity: 0, y: 100 },
            {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
            },
            '<'
        );
    }, [prevIndex]);

    return (
        <section className={classes.wrap}>
            <div className="container">
                <div className={classes.body} >
                    <div className={classes.content}>
                        <h1 ref={titleRef} className={`${classes.title} font-48-24-2`}>
                            {t(cards[prevIndex].title)}
                        </h1>
                        <h2 ref={subtitleRef} className={`${classes.subtitle} font-48-24-2`}>
                            {t(cards[prevIndex].subtitle)}
                        </h2>
                    </div>
                    <p className={`${classes.text} font-20`}>
                        {t('home.banner.text')}
                    </p>
                    <div className={classes.btn}>
                        <Button route={cards[activeIndex].url}>
                            {t('btn.learn-more')}
                        </Button>
                    </div>
                </div>
            </div>
            <Carousel
                cards={cards}
                activeIndex={activeIndex}
                prevIndex={prevIndex}
                total={total}
                onSlideClick={changeSlide}
                isAnimating={isAnimating}
            />
        </section>
    );
};

export default Banner;
